export default __webpack_public_path__ + "static/media/UMASS_Logo_DTA_SNAPEd.d1fa0bee.png";